import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../hooks";
import { AppRoutes } from "../../types/enums";
import { SettingsIcon } from "../images";
import { CustomButton } from "./CustomButton";
import { ManageSectionsBtn } from "./buttons";
import { DropdownWithQuery } from "./dropdown/DropdownWithQuery";

const tabList = [
  {
    label: "Targeted Accounts",
    path: "list",
  },
  {
    label: "Reports",
    path: "reports",
  },
];

export const ReportsTabs = ({
  isNeedUpdate,
  isDisabled,
}: {
  isNeedUpdate: boolean;
  isDisabled: boolean;
}) => {
  const navigate = useNavigate();
  const { campaign_id, tab } = useParams();
  const { isEditor } = useAppSelector((state) => state.company.userRoles);

  const isReports = tabList[1].path === tab;

  const [currentTab, setCurrentTab] = useState<{
    label: string;
    path: string;
  } | null>(null);

  useEffect(() => {
    setCurrentTab(tabList[isReports ? 1 : 0]);
  }, [tab]);

  useEffect(() => {
    if (currentTab && currentTab.path !== tab) {
      navigate(`${AppRoutes.ACCOUNTS}/${currentTab.path}/${campaign_id}`);
    }
  }, [currentTab]);

  const handleChange = (e: React.SyntheticEvent, idx: number) => {
    setCurrentTab(tabList[idx]);
  };

  return (
    <Stack flexDirection="row" gap={"24px"}>
      <Box
        sx={{
          display: "flex",
          borderBottom: "1px solid #D9D9D9",
          justifyContent: "space-between",
          alignItems: "flex-end",
          flexGrow: 1,
        }}
      >
        <Tabs
          value={isReports ? 1 : 0}
          onChange={handleChange}
          sx={{
            borderBottom: "none",
          }}
        >
          {tabList.map(({ label }, index) => (
            <Tab
              key={label}
              label={label}
              disabled={tabList.length - 1 === index && isDisabled}
              sx={{
                width: "fit-content",
                textWrap: "nowrap",
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "24px",
                "&.Mui-selected": { color: "#1C3C6C" },
                ...(tabList.length - 1 === index &&
                  isNeedUpdate && {
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      top: 14,
                      right: 10,
                      width: "6px",
                      height: "6px",
                      backgroundColor: "#FD8430",
                      borderRadius: "50%",
                    },
                  }),
              }}
            />
          ))}
        </Tabs>

        {isEditor && isReports && (
          <ManageSectionsBtn
            campaign_id={campaign_id!}
            customButton={(onClick) => (
              <CustomButton
                onClick={onClick}
                variant="outlined"
                customColor="#FFFFFF"
                textColor="#1D3E70"
                customSize={"fit"}
                sx={{
                  border: "none",
                  backgroundColor: "transparent",
                  padding: "0 6px",
                }}
                startIcon={<SettingsIcon />}
              >
                Manage Sections
              </CustomButton>
            )}
          />
        )}
      </Box>
      {!isReports && (
        <Stack flexDirection="row" gap="12px" alignItems="center">
          <Typography variant="body1" color="#585858">
            Trend Time Range:
          </Typography>
          <DropdownWithQuery
            query={"period"}
            label={""}
            items={["Last Week", "Last Month", "Last Quarter "]}
            placeholder={""}
            initSelected={"Last Month"}
            maxHeight="134px"
          />
        </Stack>
      )}
    </Stack>
  );
};
